/**
 *  商品SPU - 操作日志 - 修改前/修改后 - 点击打开弹窗展示图文详情
 */
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      dialogConfig: {
        width: 800,
        show: false,
        title: t('商品素材'),
        componentData: {},
        name: "ProDesc",
        url: require('allpages/basicData/pro_desc/pro_desc.vue').default,
        onCancel: () => {
          this.up_PS_C_PRO_LOG_DATA('') // 清空
          this.dialogConfig.show = false // 关弹窗
        }
      },
    }
  },
  mounted() {
    if (this.mainTableName == 'PS_C_PRO') {

    }
  },
  watch: {
    '$store.state.omsStore.PS_C_PRO_LOG_DATA': {
      handler(v) {
        this.dialogConfig.title = t('【商品素材】版本') + `：${v}`
        this.dialogConfig.show = Boolean(v)
      },
      immediate: true,
    }
  },
  computed: {
    mainTableName() {
      return vm.$route.params.tableName
    }
  },
  methods: {
    ...mapMutations('omsStore', ['up_PS_C_PRO_LOG_DATA']),
  }
}
